<template>
<div>
  <div class="page-header">
    <div class="page-leftheader">
      <div class="headline"><h4 class="page-title text-primary">Alle fertigen Touren</h4 ></div>
    </div>
    <div class="page-rightheader">
        <a
          class="btn btn-primary btn-pill mr-1"
          @click="openEditTrip(editTrip, 'new')"
          >Tour hinzufügen</a
        >
      <a class="btn btn-primary btn-pill" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
                    <div class="dropdown-menu border-0">
                            <a class="dropdown-item" id="dropdownToday" @click="setTimePicker('Today')">Letzte 24 Stunden</a>
                            <a class="dropdown-item" id="dropdownLastWeek" @click="setTimePicker('LastWeek')">Letzte 7 Tage</a>
                            <a class="dropdown-item" id="dropdownLastMonth" @click="setTimePicker('LastMonth')">Letzte 30 Tage</a>
                            <a class="dropdown-item active" id="dropdownAllTime" @click="setTimePicker('AllTime')">Gesamt</a>
                    </div>
    </div>
    
  </div>
  <div>
    <div>
        <input v-model="search" type="search" class="form-control form-control-sm" placeholder="Suche..." aria-controls="example1">
        <br>
    </div> 
    <div>
           
      <div>
        <div class="card">
          <!-- WAR FALSCH: Beim Zeitfilter "Letzte 24 Stunden"/"Letzte 7 Tage"
               war die Tabelle ohne jeden Hinweis leer — nichts unterschied
               "hier liegt wirklich nichts" von "die Seite ist kaputt".
               Gleiches Muster wie bei den Beiträgen (Posts.vue) und den
               Touren (Trips.vue). -->
          <div class="card-body text-center text-muted" v-if="tripsGeladen && trips.length === 0">
            Keine fertigen Touren im gewählten Zeitraum.
          </div>
          <div class="table-responsive" v-else>
            <table class="table card-table table-vcenter text-nowrap">
              <thead>
                <tr>
                  <th>Bild</th>
                  <th>Name</th>
                  <th>Aktion</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="trip in trips" :key="trip._id">
                <td class="align-middle">
                    <img
                      :src="`${$img(trip.image,$awsLargeImages)}`"
                      alt="img"
                      class="avatar avatar-md brround"
                      @error="handleImageError"
                    />
                </td>
                <td class="align-middle">{{trip.title}}</td>
                <td>
                    <a
                      title="Tour bearbeiten"
                      class="btn btn-primary btn-small mr-1"
                      @click="openEditTrip(trip, 'edit')"
                      ><i class="fas fa-edit"></i
                    ></a>
                    <a
                      title="Tour löschen"
                      class="btn btn-small btn-danger"
                      @click="openDeleteTrip(trip)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
              </tr>
            </tbody>
            </table>
          </div>
          <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
        </div>
      </div>
      <v-dialog
        v-model="editDialog"
        width="500"
      >
        <v-card>
          <v-card-title class="card">
            <!-- WAR FALSCH: Der Titel stand fest auf "Tour bearbeiten" — auch
                 beim Anlegen über "Tour hinzufügen". Gleiches Muster wie der
                 Dialog-Titel in Events.vue/Trips.vue. -->
            <h4 class="page-title text-primary">{{ editTrip.editType == 'new' ? 'Fertige Tour anlegen' : 'Tour bearbeiten' }}</h4>
          </v-card-title>
          <v-card-text>
              <div class="form-group">
              <label class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="Name"
                v-model="editTrip.title"
                v-bind:class="{'is-invalid': emptyValidation && (editTrip.title == null || editTrip.title == '')}"
              />
            </div>

            <div class="form-group">
              <label class="form-label">Bild</label>
              <div class="card overflow-hidden shadow-none border" v-if="this.editTrip.editType == 'edit'">
                  <img :src="`${$img(editTrip.image,$awsLargeImages)}`" alt="image" class="card-image1 " @error="handleImageError">
              </div>
              <div class="card overflow-hidden shadow-none border" v-if="updatedPic">
                  <img
                    :src="updatedPic"
                    alt="image"
                    class="img-thumb"
                  />
              </div>
              <div class="input-group file-browser mb-5 mt-4">
                <input
                  type="text"
                  class="form-control browse-file"
                  id="imageFileDisplay"
                  placeholder=""
                  readonly=""
                  v-bind:class="{'is-invalid': emptyValidation && checkFileInput() && (editTrip.image == null || editTrip.image == '')}"
                />
                <label class="input-group-text btn btn-primary">
                  Durchsuchen
                  <input
                    id="imageFile"
                    type="file"
                    class="file-browserinput"
                    style="display: none"
                    multiple=""
                    accept="image/png, image/jpeg"
                    v-on:change="setFileName()"
                  />
                </label>
              </div>
          </div>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <a class="btn btn-primary btn-pill mr-1" @click="editDialog=false">Abbrechen</a>
          <a class="btn btn-primary btn-pill" @click="saveTrip(trip)">Speichern</a>
        </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog 
        v-model="deleteDialog"
        width="500">
        <v-card>
          <v-card-title class="card">
              <h4 class="page-title text-primary">Tour löschen</h4>
            </v-card-title>
            <v-card-text>
              Sind Sie sicher, dass Sie diese Tour löschen wollen?
            </v-card-text>
            <v-divider></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <!-- Rief closeDeleteTrip auf — diese Methode gab es nie, der Klick lief
                   ins Leere und fertige Trips ließen sich gar nicht löschen. -->
              <a class="btn btn-danger btn-pill" @click="deleteTrip(editTrip)">Löschen</a>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="emptyDialog" width="500">
      <v-card>
        <v-card-title class="card">
            <h4 class="page-title text-primary">Fehler</h4>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          Zum Speichern müssen alle erforderlichen Felder ausgefüllt sein.
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill" @click="emptyDialog=false">Okay</a>
          </v-card-actions>
      </v-card>
    </v-dialog>
      
      </div>
    </div>
  
</div>
</template>

<script>
export default {

  components: {
  },

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      // Steht auf false, solange die erste Antwort des Servers aussteht.
      // WAR FALSCH: Der Leerhinweis hing allein an trips.length === 0 — das
      // trifft aber auch WÄHREND des Ladens zu. Auf einer langsamen
      // Verbindung stand dort erst "Keine fertigen Touren", einen Augenblick
      // später die volle Tabelle. Gleiche Korrektur wie in Trips.vue.
      tripsGeladen: false,
      sort: null,
      order: true,
      routes: {
        tenants: "/api/tenant",
        filter: "/api/tenants/search/"
      },
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      tenants: [
        {
          name: '',

        }
      ],
      roles: [],
      createTenantPopup: false,
      menu: false,
      createmode: true,

      // Personal Data
      me: null,

    trips: [],
    editTrip: {},
    trip: '',
    updatedPic: '',
    

    editDialog: false,
    deleteDialog: false,
    emptyDialog: false,
    emptyValidation: false,

    currentTimeSpan: 'AllTime'
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      if (this.search == "") {
        this.fetchTrip();
      } else {
        this.page = 0;
        this.searchTrip();
      }
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    }
  },

  mounted() {
    this.fetchTrip();
    console.log(this.trips);
  },

  methods: {
    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                // WAR FALSCH: Es wurde nur weiter nachgeladen, wenn die letzte
                // Seite GENAU ElementPerPage Einträge lieferte. Bei "Letzte 24
                // Stunden"/"Letzte 7 Tage" antwortet der Server bei leerem
                // Ergebnis ohne das Feld "data" (siehe fetchTrip()) — außerdem
                // schneidet die Datenbankabfrage erst die Seite heraus, eine
                // Seite mit weniger als ElementPerPage Einträgen bedeutet also
                // nicht zwangsläufig "Ende der Liste". Jetzt wird
                // weitergeladen, solange die letzte Anfrage überhaupt etwas
                // geliefert hat.
                if(this.lastTrips > 0 || this.lastTrips == null){
                  console.log(this.page);
                  if(this.search ==  "" || this.search == null){
                    this.page++;
                    // Nachgeladen wurde über /trip/all — also die normalen Trips,
                    // während der Erstabruf /trip/presetTrip/all verwendet. Beim
                    // Scrollen landeten dadurch fremde Trips in der Liste der
                    // fertigen Trips.
                    this.$axios
                          .get('/trip/presetTrip/all/' + this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan())
                          .then(function (response){
                            // Absicherung wie in fetchTrip(): bei leerem Ergebnis
                            // fehlt das Feld "data" ganz, ein blinder Zugriff auf
                            // .length riss hier sonst mit einem TypeError ab.
                            const data = (response.data && response.data.data) || [];
                            _this.lastTrips = data.length;
                            if(data.length >= 1) {
                              data.forEach(item => _this.trips.push(item));
                            }
                          })
                          .catch(this.onError);
                  }
                  else{
                    console.log('infinitesearch');
                    this.page++;
                    // Wie oben: /trip/search suchte in den normalen Trips statt in den
                    // fertigen Trips. Zusätzlich muss der Suchbegriff kodiert werden,
                    // sonst zerlegt ein "/" im Suchtext die Route.
                    this.$axios.get('/trip/presetTrip/search/' + encodeURIComponent(this.search) +'/'+ this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
                      _this.lastTrips = response.data.data.length;
                      if(response.data.data.length >= 1) {
                        response.data.data.forEach(item => _this.trips.push(item));
                      }
                    }).catch(function(error){
                      console.error(error);
                    });
                  }
                }
            }, 500);
        }
    },
    fetchTrip() {
      var _this = this;
      // fetchTrip lädt immer ab Position 0, setzte aber den Seitenzähler nicht
      // zurück. Nach dem Scrollen sprang das nächste Nachladen mitten in die
      // Liste — beim Leeren der Suche und beim Wechsel des Zeitraums fehlten
      // dadurch alle Trips dazwischen.
      this.page = 0;
      this.$axios.get('/trip/presetTrip/all/0/'+ this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
        // WAR FALSCH: Bei "Letzte 24 Stunden"/"Letzte 7 Tage" antwortet der
        // Server, wenn im Zeitraum nichts liegt, mit success:false OHNE das
        // Feld "data" — response.data.data war dann undefined. Die Tabelle
        // wurde damit unbemerkt auf undefined gesetzt, und die anschließende
        // .length-Abfrage brach mit einem TypeError ab, der nur in der
        // Browser-Konsole landete ("Letzte 24 Stunden" zeigte dadurch eine
        // leere Tabelle ohne jeden Hinweis, und das Nachladen blieb danach
        // dauerhaft stehen).
        const data = (response.data && response.data.data) || [];
        _this.trips = data;
        _this.lastTrips = data.length;
        _this.tripsGeladen = true;
      }).catch(function(error){
        console.error(error);
        // Auch im Fehlerfall setzen, sonst bleibt der Bildschirm dauerhaft
        // ohne Tabelle UND ohne Hinweis stehen.
        _this.tripsGeladen = true;
      });
    },
    searchTrip() {
      var _this = this;
      this.$axios
        .get(
          // Suchbegriff kodieren: unkodiert brach ein "/" im Suchtext die Route
          // auf und die Suche lieferte einen Fehler statt Ergebnissen.
          "/trip/presetTrip/search/" +
            encodeURIComponent(this.search) +
            "/" +
            this.page +
            "/" +
            this.ElementPerPage
             + '/' + this.getCurrentTimeSpan()
        )
        .then(function (response) {
          _this.trips = response.data.data;
          _this.lastTrips = _this.trips.length;
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        // this.console gibt es nicht — der Fehlerbehandler warf hier selbst
        // und verdeckte damit die eigentliche Ursache.
        console.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    // Fängt eine kaputte Bildadresse ab (Datei im Bildspeicher gelöscht,
    // Upload nur halb durchgelaufen). Ohne diesen Rückfall zeigte der
    // Browser in jeder betroffenen Tabellenzeile nur das zerbrochene
    // Bildsymbol.
    // WAR FALSCH (zweimal): Zuerst setzte die Bremse "event.target.onerror =
    // null" — das löscht nur die alte HTML-Eigenschaft onerror, die hier nie
    // benutzt wird. Die Vorlage meldet den Rückfall über "@error", Vue
    // registriert das intern per addEventListener; dieser Zuhörer blieb
    // aktiv, setzte bei einem scheiternden Ersatzbild erneut dieselbe
    // Adresse und drehte sich damit endlos im Kreis. Der zweite Anlauf
    // merkte sich den Rückfall dauerhaft am Bild-Element selbst
    // ("data-fallback-used"). Das bremste zwar die Schleife, galt aber für
    // IMMER: Die Tabellenzeilen haben einen festen Schlüssel (:key), Vue
    // verwendet dasselbe Bild-Element über jedes Neuladen der Liste hinweg
    // weiter. Lud der Verwalter danach ein neues, ebenfalls kaputtes Bild
    // hoch, bekam diese Zeile keinen Rückfall mehr und zeigte wieder das
    // zerbrochene Bildsymbol des Browsers. Jetzt wird nicht mehr gemerkt
    // "Rückfall schon einmal benutzt", sondern geprüft, ob die AKTUELLE
    // Adresse bereits das Ersatzbild ist — das bremst genau die echte
    // Schleife (das Ersatzbild scheitert selbst) und lässt jedes neue Bild
    // wieder zu.
    handleImageError(event) {
      const fallbackImage = '/images/brand/favicon.png';
      if (event.target.getAttribute('src') === fallbackImage) return;
      event.target.src = fallbackImage;
    },
    openEditTrip(trip, type) {
      if(type == "new") {
        this.initializeTrip();
      } else {
        // WAR FALSCH: Hier stand `this.editTrip = trip;` — damit zeigte
        // editTrip auf GENAU DASSELBE Objekt wie die Tabellenzeile. FOLGE
        // (gemessen): Jede Eingabe im Dialog (z.B. im Namensfeld) änderte
        // sofort auch die Zeile in der Tabelle dahinter mit. "Abbrechen" gab
        // es damit nur dem Anschein nach — der geänderte Name blieb in der
        // Liste stehen, obwohl nichts gespeichert wurde, bis die Seite neu
        // geladen wurde. Gleiches Muster, gleicher Fix wie openEditEvent() in
        // Events.vue / openEditTrip() in Trips.vue: eine echte Kopie
        // anlegen, statt die Tabellenzeile direkt zu bearbeiten.
        this.editTrip = JSON.parse(JSON.stringify(trip));
      }
      // editType wird erst HIER, nach initializeTrip()/der Kopie, gesetzt —
      // nicht davor. Stünde diese Zeile vor dem if/else, würde sie im Zweig
      // "new" vom frischen Objekt aus initializeTrip() sofort wieder
      // überschrieben (editType wäre dort nie 'new'), und "Trip hinzufügen"
      // hätte ein PUT /trip/presetTrip/update mit leerer Kennung geschickt
      // statt ein POST /trip/presetTrip/add. Das war schon einmal der
      // Fehler hier — deshalb diese Reihenfolge bewusst so lassen.
      this.editTrip.editType = type;
      this.editDialog = true;
    },
    openDeleteTrip(trip) {
      this.editTrip = trip;
      this.deleteDialog = true;
    },
    // Diese Methode fehlte vollständig: Der Löschen-Knopf rief das nicht
    // vorhandene closeDeleteTrip auf, die Route /trip/presetTrip/delete/:presetTripId
    // wurde nirgends verwendet und fertige Trips ließen sich nicht löschen.
    deleteTrip(trip) {
      let _this = this;
      this.$axios
        .delete('/trip/presetTrip/delete/' + trip._id)
        .then(function (response) {
          console.log(response.data);
          // WAR FALSCH: Als einzige der fünf Inhaltsseiten wertete das Löschen
          // hier die Antwort überhaupt nicht aus. Zwei getrennte Löcher:
          //
          // 1. Fachlicher Fehlschlag: Dieses Backend antwortet auch dann mit
          //    Statuscode 200, wenn nichts gelöscht wurde, und schreibt das
          //    Ergebnis nur ins Feld "success" (z.B. bei fehlender
          //    Berechtigung). Ohne die Prüfung schloss sich der Dialog, die
          //    Liste lud neu, und die Vorlage stand weiter da — ohne Meldung.
          // 2. Echter Fehler (Netz weg, Server antwortet 4xx/5xx): Der
          //    catch-Zweig schrieb nur in die Konsole. Für den Verwalter
          //    passierte schlicht nichts, der Dialog blieb offen stehen.
          //
          // NICHT geheilt ist damit der andere Teil desselben Funds: Der
          // Server (tripController.deletePresetTrip) setzt ohne jede
          // Existenzprüfung ein deleteOne ab und meldet danach ausnahmslos
          // Erfolg. Eine bereits gelöschte Vorlage lässt sich deshalb
          // beliebig oft "erfolgreich" löschen — das kann keine Prüfung im
          // Dashboard erkennen, solange der Server nie success:false sagt.
          // Sobald er es tut (wie eventController es inzwischen tut), greift
          // die Prüfung hier von allein.
          if (response.data && response.data.success === false) {
            console.error(response.data.message);
            _this.$showCommonError();
            return;
          }
          _this.deleteDialog = false;
          _this.fetchTrip();
        })
        .catch(function (error) {
          console.error(error);
          _this.$showCommonError();
        });
    },
    saveTrip() {
      let _this = this;
      this.emptyValidation = true;
      this.$forceUpdate();


      Vue.nextTick(() => {
        _this.saveTripToServer();
      });
    },
    saveTripToServer() {
      let _this = this;
      if(document.getElementsByClassName('is-invalid').length > 0) {
        this.emptyDialog = true;
        return;
      }

      let fileToUpload;
      const tripToSave = Object.assign({}, this.editTrip);
      tripToSave.presetTripId = tripToSave._id;

      delete tripToSave._id;
      delete tripToSave.status;
      delete tripToSave.user;
      delete tripToSave.__v;
      delete tripToSave.createdAt;
      delete tripToSave.updatedAt;
      delete tripToSave.editType;
      

      if(document.getElementById('imageFile').files.length > 0 ) {
        if(((document.getElementById('imageFile').files[0].size/1024)/1024).toFixed(4) > 20) {
          this.$showErrorFileSize(20);
          return;
        }
        fileToUpload = document.getElementById('imageFile').files[0];
        delete tripToSave.image;
      }

      if(this.editTrip.editType == 'new') {
        delete tripToSave.presetTripId;
        const body = this.$formatUrlEncoded(tripToSave, fileToUpload);
        this.$axios.post('/trip/presetTrip/add', body).then(function(response){
          console.log(response.data);
          // WAR FALSCH: Die Antwort wurde nicht auf "success" geprüft. Ein
          // fachlicher Fehlschlag reist mit Statuscode 200 an — ohne diese
          // Prüfung schloss sich der Dialog trotzdem, der Verwalter sah
          // scheinbar Erfolg, gespeichert wurde aber nichts. Gleiches Muster
          // wie saveEventToServer() in Events.vue.
          if (response.data && response.data.success === false) {
            console.error(response.data.message);
            _this.$showCommonError();
            return;
          }
          _this.editDialog = false;
          // Nach dem Speichern wurde die Liste nicht neu geladen — der neue Trip
          // tauchte erst nach einem Neuladen der Seite auf.
          _this.fetchTrip();
        }).catch(function(error){
          console.error(error);
          _this.$showCommonError();
        });
      } else {
        const body = this.$formatUrlEncoded(tripToSave, fileToUpload);
        this.$axios.put('/trip/presetTrip/update', body).then(function(response){
          console.log(response.data);
          // Gleicher Fall wie oben bei /trip/presetTrip/add: HTTP 200 mit
          // success:false ist ein fachlicher Fehlschlag, kein Erfolg.
          if (response.data && response.data.success === false) {
            console.error(response.data.message);
            _this.$showCommonError();
            return;
          }
          _this.editDialog = false;
          // Gleiches Problem beim Bearbeiten: die Änderung war erst nach einem
          // Neuladen der Seite sichtbar.
          _this.fetchTrip();
        }).catch(function(error){
          console.error(error);
          _this.$showCommonError();
        });
      }
    },
    initializeTrip() {
        this.editTrip = {
        _id: "",
        createdAt: "",
        image: "",
        status: "",
        title: "",
        updatedAt: "",
        user: "",
        // editType fehlte hier — nachträglich gesetzte Felder sind in Vue 2 nicht
        // reaktiv, die Bildvorschau im Dialog richtet sich aber danach.
        editType: "",
      };
      this.updatedPic = '';
    },
    checkFileInput() {
      if(document.getElementById('imageFile').files.length == 0) {
        return true;
      }
      return false;
    },
    setFileName() {
       let path = document.getElementById('imageFile').value;
       console.log(path);
       if(path) {
         var startIndex = path.lastIndexOf("\\");
         document.getElementById('imageFileDisplay').value = path.substring(startIndex + 1);
         this.updatedPic = URL.createObjectURL(document.getElementById('imageFile').files[0]);
       } else {
         document.getElementById('imageFileDisplay').value = '';
       }
    },
    setTimePicker(timeSpan) {
      console.log(timeSpan);
           let currentId = 'dropdown' + this.currentTimeSpan;
           let newId = 'dropdown' + timeSpan;

           document.getElementById(currentId).classList.remove('active');
           document.getElementById(newId).classList.add('active');

           this.currentTimeSpan = timeSpan;
           this.setCurrentTimeSpan(timeSpan);
       },
    setCurrentTimeSpan(timeSpan) {
      this.currentTimeSpan = timeSpan;
      this.fetchTrip();
    },
    getCurrentTimeSpan() {
      let time = -1;
      if(this.currentTimeSpan == 'Today') {
          time = 1;
      } else if (this.currentTimeSpan == 'LastWeek') {
          time = 7;
      } else if (this.currentTimeSpan == 'LastMonth') {
          time = 30;
      } else if (this.currentTimeSpan == 'AllTime') {
          time = -1;
      }

      return time;
    }
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}
</style>

